import React from "react";

function RegistrationCompletion() {
  return (
    <>
      <div className="container py-5">
        <div className="row py-4">
          <div className="col-lg-4 d-none d-lg-block">
            <img
              src="congratulations.jpg"
              alt="Verification of Registration"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-8" style={{ textAlign: "justify" }}>
            <h1 className="display-4 " style={{ color: "dodgerblue" }} id="accountCreatedHeading">
              Account Created
            </h1>
            <hr></hr>
            <p className="lead text-muted mb-0">
              <strong>
                We have sent an email with a confirmation link to your email
                address.
              </strong>
            </p>

            <p className="lead text-muted mb-0">
              In order to complete the registration process by verifiying your
              account, Please click the confirmation link attached with email.
              If you do not receive a confirmation email, please check your spam
              folder.
            </p>
            <p className="lead text-underlined mb-0">
              Also, please verify that you entered a valid email address during
              registration process.
            </p>
            <hr></hr>
            <p
              className="lead text-underlined  mb-0"
              style={{ marginTop: "15px" }}
            >
              Already verified your account!!{" "}
              <a className="btn btn-success" href="/user-login">
                Go to Login
              </a>
            </p>
          </div>
          <div
            className="container py-2 align-items-center"
            style={{ textAlign: "center" }}
          >
            <p className="lead">
              <strong>
                If you need any kind of assistance related to this, feel free to
                <a href="/"> contact us</a>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegistrationCompletion;
